import router 	from '@/router'
import axios 	from 'axios'

const alertsUrl = process.env.API_URL

export default {
	
	getAllertsForSite ({ commit }, { restId })  {
		return axios.get(`${alertsUrl}/events/${restId}`)
			.then(res => {
				commit('setAlerts', { alerts: res.data });
			})
	},

	addAlert ({ commit }, { newAlert }) {
		delete newAlert.createdAt
		delete newAlert.updatedAt
		delete newAlert.expires
		
		commit('addAlert', { newAlert })
	},

	completeAlert ({ commit }, { alert } ) {
		return axios.post(`${alertsUrl}/status/${alert.id}/complete`)
			.then(res => {
				commit('updateAlertStatus', { alert, status: 'complete' })
			})
			
	},

	unCompleteAlert ({ commit }, { alert } ) {
		return axios.post(`${alertsUrl}/status/${alert.id}/uncomplete`)
			.then(res => {
				commit('updateAlertStatus', { alert, status: 'pending' })
			})
	},

	setRestId ({ commit }, { restId } ) {
		commit('setRestid', { restId })
		router.push('/alerts')
		
	}
}



// WEBPACK FOOTER //
// ./src/store/alerts/actions.js